module.exports = __webpack_public_path__ + "img/6b30473af4dfb07be2d56525880d2b03.6b30473a.png";